export default {
  "profile.title": "Mi perfil",
  "profile.overview": "Resumen",
  "profile.myBookings": "Mis reservas",
  "profile.myFavorites": "Mis favoritos",
  "profile.myReviews": "Mis reseñas",
  "profile.paymentMethods": "Métodos de pago",
  "profile.paymentsSecureTitle": "Pagos seguros con Mercado Pago",
  "profile.paymentsSecureBody": "Tus pagos se procesan de forma segura a través de Mercado Pago. BajApp Xperiences nunca almacena los datos de tu tarjeta; los ingresas directamente en Mercado Pago al momento de reservar.",
  "profile.paymentsMethodsNote": "Métodos aceptados: tarjetas de crédito y débito, OXXO y transferencia bancaria (SPEI), a través de Mercado Pago.",
  "profile.notifications": "Notificaciones",
  "profile.security": "Seguridad",
  "profile.saved": "Guardado",
  "profile.recentBookings": "Reservas recientes",
  "profile.viewAll": "Ver todas",
  "profile.statsBookings": "Reservas",
  "profile.statsFavorites": "Favoritos",
  "profile.statsReviews": "Reseñas",
  "profile.statsSavings": "Ahorros",
  "profile.bookings": "Mis reservas",
  "profile.favorites": "Favoritos",
  "profile.settings": "Configuración",
  "profile.editProfile": "Editar perfil",
  "profile.save": "Guardar cambios",
  "profile.cancel": "Cancelar",
  "profile.fullName": "Nombre completo",
  "profile.email": "Correo electrónico",
  "profile.phone": "Teléfono",
  "profile.bio": "Sobre mí",
  "profile.location": "Ubicación",
  "profile.changePhoto": "Cambiar foto",
  "profile.upcoming": "Próximas",
  "profile.past": "Pasadas",
  "profile.cancelled": "Canceladas",
  "profile.noBookings": "Aún no tienes reservas",
  "profile.exploreTours": "Explorar tours",
  "profile.bookingId": "Reserva",
  "profile.date": "Fecha",
  "profile.status": "Estado",
  "profile.total": "Total",
  "profile.viewDetails": "Ver detalles",
  "profile.bookAgain": "Reservar de nuevo",
  "profile.guests": "viajeros",
  "profile.cancelBooking": "Cancelar reserva",
  "profile.leaveReview": "Dejar reseña",
  "profile.viewVoucher": "Ver voucher",
  "profile.noFavorites": "Aún no tienes favoritos",
  "profile.remove": "Eliminar",
  "profile.language": "Idioma",
  "profile.password": "Cambiar contraseña",
  "profile.currentPassword": "Contraseña actual",
  "profile.newPassword": "Nueva contraseña",
  "profile.confirmPassword": "Confirmar contraseña",
  "profile.deleteAccount": "Eliminar cuenta",
  "profile.deleteWarning": "Esta acción no se puede deshacer. Todos tus datos, reservas y reseñas serán eliminados permanentemente.",
  "profile.memberSince": "Miembro desde",
  "profile.logout": "Cerrar sesión",
  "profile.statusConfirmed": "Confirmada",
  "profile.statusPending": "Pendiente",
  "profile.statusCancelled": "Cancelada",
  "profile.statusCompleted": "Completada",
  "profile.emailNotifications": "Notificaciones por correo",
  "profile.emailBookingsLabel": "Nueva reserva",
  "profile.emailBookingsDesc": "Recibir correo cuando confirmes una reserva",
  "profile.emailPromosLabel": "Promociones",
  "profile.emailPromosDesc": "Recibir ofertas especiales y descuentos",
  "profile.emailNewsletterLabel": "Boletín",
  "profile.emailNewsletterDesc": "Recibir nuestro boletín mensual",
  "profile.pushNotifications": "Notificaciones push",
  "profile.pushBookingsLabel": "Recordatorios de reserva",
  "profile.pushBookingsDesc": "Notificaciones antes de tu tour",
  "profile.pushReviewsLabel": "Nuevas reseñas",
  "profile.pushReviewsDesc": "Cuando respondan tus reseñas",
  "profile.smsRemindersLabel": "SMS",
  "profile.smsRemindersDesc": "Recordatorios por mensaje de texto",
  "profile.changePassword": "Cambiar contraseña",
  "profile.changePasswordDesc": "Por seguridad, te enviamos un enlace a tu correo para que cambies tu contraseña.",
  "profile.sendResetLink": "Enviarme el enlace",
  "profile.sendingResetLink": "Enviando…",
  "profile.resetLinkSent": "Listo. Revisa tu correo (y la carpeta de spam).",
  "profile.resetLinkError": "No pudimos enviar el enlace. Inténtalo más tarde.",
  "profile.twoFactor": "Autenticación de dos factores",
  "profile.twoFactorDesc": "Añade una capa extra de seguridad a tu cuenta",
  "profile.activeSessions": "Sesiones activas",
  "profile.currentDevice": "Este dispositivo",
  "profile.activeNow": "Activo ahora",
  "profile.deleteTitle": "¿Estás seguro?",
  "profile.deleteLoss1": "Perderás todas tus reservas y vouchers",
  "profile.deleteLoss2": "Tus reseñas serán eliminadas",
  "profile.deleteLoss3": "No podrás recuperar tu cuenta",
  "profile.continueDelete": "Continuar",
  "profile.deleteReasonTitle": "¿Por qué nos dejas?",
  "profile.deleteReasonDesc": "Tu opinión nos ayuda a mejorar",
  "profile.reason1": "No encontré los tours que buscaba",
  "profile.reason2": "Los precios son muy altos",
  "profile.reason3": "Tuve una mala experiencia",
  "profile.reason4": "Otro",
  "profile.deleteConfirm": "Entiendo que esta acción es irreversible",
  "profile.deleteAccountBtn": "Eliminar mi cuenta",
  "profile.deleteDoneTitle": "Cuenta eliminada",
  "profile.deleteDoneDesc": "Sentimos verte partir. Tu cuenta ha sido eliminada.",
  "profile.backHome": "Volver al inicio",
  "profile.noReviews": "Aún no has dejado reseñas",
  "profile.backToBookings": "Volver a reservas",
  "profile.backToBookingDetail": "Volver a la reserva",
  "profile.bookingNotFound": "Reserva no encontrada",
  "profile.bookingDetails": "Detalles de la reserva",
  "profile.bookingDate": "Fecha de reserva",
  "profile.paymentInfo": "Información de pago",
  "profile.paymentMethod": "Método de pago",
  "profile.paymentId": "ID de pago",
  "profile.providerContact": "Contacto del proveedor",
  "profile.adults": "Adultos",
  "profile.children": "Niños",
  "profile.cancelReason": "Motivo de cancelación",
  "profile.cancelComment": "Comentarios (opcional)",
  "profile.cancelCommentPlaceholder": "Cuéntanos más sobre por qué cancelas...",
  "profile.cancelWarning": "Esta acción es irreversible. Las políticas de reembolso aplican según la política de cancelación.",
  "profile.goBack": "Volver",
  "profile.confirmCancel": "Confirmar cancelación",
  "profile.cancelSuccess": "Reserva cancelada correctamente.",
  "profile.redirecting": "Redirigiendo...",
  "profile.yourRating": "Tu calificación",
  "profile.reviewComment": "Tu reseña",
  "profile.reviewCommentPlaceholder": "Comparte tu experiencia con este tour...",
  "profile.sendReview": "Enviar reseña",
  "profile.reviewSuccess": "Reseña enviada. ¡Gracias!",
  "profile.cancelReasons.cambio_fechas": "Cambio de fechas",
  "profile.cancelReasons.emergencia_personal": "Emergencia personal",
  "profile.cancelReasons.mal_clima": "Mal clima",
  "profile.cancelReasons.encontrar_mejor_precio": "Encontré mejor precio",
  "profile.cancelReasons.doble_reserva": "Doble reserva",
  "profile.cancelReasons.otro": "Otro",
  "profile.activityLog": "Seguimiento de la reserva",
  "profile.timeline.booking_created": "Reserva creada",
  "profile.timeline.payment_received": "Pago recibido",
  "profile.timeline.booking_confirmed": "Reserva confirmada",
  "profile.timeline.reminder_sent": "Recordatorio enviado",
  "profile.timeline.tour_completed": "Tour completado",
  "profile.timeline.review_requested": "Reseña solicitada",
  "profile.timeline.booking_cancelled": "Reserva cancelada",
  "profile.timeline.refund_processed": "Reembolso procesado",
  "profile.reviews": "reseñas",
  "profile.saving": "Guardando…",
  "profile.loading": "Cargando…",
  "profile.notif.all": "Todas",
  "profile.notif.unread": "No leídas",
  "profile.notif.markAllRead": "Marcar todas como leídas",
  "profile.notif.preferences": "Preferencias",
  "profile.notif.empty": "No tienes notificaciones.",
  "profile.notif.justNow": "Hace un momento",
  "profile.notif.minsAgo": "Hace {{n}} min",
  "profile.notif.hoursAgo": "Hace {{n}} h",
  "profile.notif.daysAgo": "Hace {{n}} d",
  "profile.notifEmail": "Correo electrónico",
  "profile.notifEmailDesc": "Confirmaciones de reserva y avisos importantes por email.",
  "profile.notifWhatsApp": "WhatsApp",
  "profile.notifWhatsAppDesc": "Confirmaciones y recordatorios por WhatsApp.",
  "profile.prefsSaved": "Preferencias guardadas.",
  "profile.loadError": "No pudimos cargar la información. Inténtalo de nuevo.",
  "profile.saveError": "No pudimos guardar los cambios. Inténtalo de nuevo.",
  "profile.emailReadOnly": "Para cambiar tu correo, escríbenos desde la página de contacto.",
  "profile.statsSpent": "Total",
  "profile.discount": "Descuento",
  "profile.reviewTitle": "Título (opcional)",
  "profile.reviewError": "No pudimos enviar la reseña. Intenta de nuevo.",
  "profile.reviewNotOwner": "No puedes reseñar esta reserva.",
  "profile.reviewOnlyCompleted": "Solo puedes dejar una reseña después de que el tour haya finalizado.",
  "profile.cancelNotAllowed": "Esta reserva ya no se puede cancelar.",
  "profile.cancelError": "No pudimos cancelar la reserva. Inténtalo de nuevo.",
  "profile.removeFromFavorites": "Quitar de favoritos",
  "profile.currentDeviceInfo": "Chrome · La Paz, México",
};